module.exports = __webpack_public_path__ + "img/19-avatar male.e601e5cd.png";